import React from "react";
import { FaTicketAlt } from "react-icons/fa";

const BackdropSpinner = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-gray-900 to-black flex items-center justify-center z-50 overflow-hidden">
      {/* Starry Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 animate-twinkle bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20"></div>
      </div>

      {/* Spinner Container */}
      <div className="relative w-64 h-64 flex items-center justify-center">
        {/* Neon Outer Ring */}
        <div className="absolute w-64 h-64 border-8 border-transparent border-t-purple-500 border-b-blue-500 rounded-full animate-spin shadow-[0_0_20px_5px_rgba(128,0,255,0.5)]"></div>

        {/* Middle Spinning Ring */}
        <div className="absolute w-48 h-48 border-4 border-transparent border-l-pink-400 border-r-yellow-300 rounded-full animate-[spin_2s_linear_reverse_infinite] shadow-lg"></div>

        {/* Inner Glowing Core */}
        <div className="absolute w-36 h-36 bg-gradient-to-br from-yellow-300 to-orange-400 rounded-full shadow-[0_0_30px_10px_rgba(255,140,0,0.5)] animate-pulse"></div>

        {/* Orbiting Particles */}
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`absolute w-4 h-4 bg-blue-500 rounded-full animate-orbit opacity-75`}
            style={{
              animationDelay: `${i * 0.2}s`,
              transformOrigin: "32px",
            }}
          ></div>
        ))}

        {/* Icon with Shadow Glow */}
        <div className="absolute flex items-center justify-center w-20 h-20 bg-gradient-to-r from-white to-gray-200 rounded-full shadow-[0_0_25px_10px_rgba(255,255,255,0.7)]">
          <FaTicketAlt className="text-red-500 text-5xl animate-bounce" />
        </div>
      </div>
    </div>
  );
};

export default BackdropSpinner;
